// lib/bunny.js
class BunnyClient {
  constructor() {
    // Vos variables d'environnement exactes
    this.storageZoneName = import.meta.env.VITE_BUNNYCDN_STORAGE_ZONE; // "PlomberiePro"
    this.accessKey = import.meta.env.VITE_BUNNYCDN_API_KEY; // "0765eba1-42fb-4950-b67b76555891-75fc-4414"
    this.storageEndpoint = import.meta.env.VITE_BUNNYCDN_STORAGEENDPOINT; // "https://storage.bunnycdn.com/PlomberiePro/images/"
    this.cdnUrl = import.meta.env.VITE_BUNNYCDN_STORAGE_URL; // "https://PlomberiePro.b-cdn.net/images"

    // Validation
    if (!this.storageZoneName || !this.accessKey) {
      throw new Error('Configuration BunnyCDN manquante dans .env');
    }
  }

  /**
   * Upload une image vers BunnyCDN
   */
  async uploadImage(file) {
    try {
      // Générer un nom de fichier unique
      const extension = file.name.split('.').pop();
      const filename = `${Date.now()}-${Math.random().toString(36).substring(2, 9)}.${extension}`;

      // URL complète pour l'upload
      const uploadUrl = `https://storage.bunnycdn.com/${this.storageZoneName}/images/${filename}`;

      console.log('📤 Upload vers:', uploadUrl);

      // Upload vers BunnyCDN
      const response = await fetch(uploadUrl, {
        method: 'PUT',
        headers: {
          'AccessKey': this.accessKey,
          'Content-Type': file.type
        },
        body: file
      });

      if (!response.ok) {
        throw new Error(`Upload échoué: ${response.status} ${response.statusText}`);
      }

      // URL finale pour affichage
      const finalUrl = `${this.cdnUrl}/${filename}`;
      console.log('✅ Upload réussi:', finalUrl);

      return finalUrl;

    } catch (error) {
      console.error('❌ Erreur BunnyCDN:', error);
      throw error;
    }
  }

  /**
   * Supprimer une image
   */
  async deleteImage(filename) {
    try {
      const deleteUrl = `https://storage.bunnycdn.com/${this.storageZoneName}/images/${filename}`;
      
      const response = await fetch(deleteUrl, {
        method: 'DELETE',
        headers: {
          'AccessKey': this.accessKey
        }
      });

      return response.ok;
    } catch (error) {
      console.error('❌ Erreur suppression:', error);
      throw error;
    }
  }
}

// Export unique (comme Supabase)
export const bunny = new BunnyClient();